import { PaymentBubble } from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function CompletePaymentBubble({
  chatMessage,
  history
}: PaymentBubbleCommonProps) {
  const totalAmount = (chatMessage?.rfq?.purchaseAmount ?? 0).toLocaleString(
    'ko'
  );
  const onClickButton = () => {
    if (!history) return;
    const { pathname } = history.location;
    history.push(`${pathname}?menu=purchaseorder`);
  };

  return (
    <PaymentBubble>
      <PaymentBubble.Title>결제 완료되었습니다.</PaymentBubble.Title>
      <PaymentBubble.Stepper activeStep={1} />
      <PaymentBubble.Content>
        이제 파트너가 제조를 시작할 수 있습니다.
      </PaymentBubble.Content>
      <PaymentBubble.Content>
        총 결제금액 : {totalAmount}원
      </PaymentBubble.Content>
      <PaymentBubble.Button buttonAction={onClickButton}>
        제조현황 확인
      </PaymentBubble.Button>
    </PaymentBubble>
  );
}
